<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "settings"
};
</script>

<style lang="scss"></style>
